<template>
	<div class="news-detail-page">
		<!-- 页面头部（导航栏 + 面包屑） -->
		<newsPageHeader :ztype="1" :zname="$t('newsMsg.t1')" />

		<!-- 内容区域 -->
		<div class="detail-content-section animate__animated animate__fadeInUp">
			<div class="detail-card">
				<!-- 文章标题 -->
				<h1 class="article-title">{{pagemsg.title}}</h1>

				<!-- 发布日期 -->
				<p class="article-date">{{$t('newsMsg.t2')}}：{{pagemsg.createTime}}</p>

				<!-- 文章配图 -->
				<!-- <div class="article-cover-wrap">
					<el-image class="article-cover" :src="require('@/static/CodeBuddyAssets/31159_2065/9.png')" fit="cover"></el-image>
				</div> -->

				<!-- 分隔线 -->
				<!-- <div class="content-divider"></div> -->

				<!-- 文章正文区域 -->
				<div class="article-body">
					<div class="article-text" v-html="pagemsg.content"></div>
					
					<!-- 正文段落 -->
					<!-- <div class="article-text">
						<p class="text-para">
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Lazada预计2018年200万新消费者将加入网购大军，消费者每月网购的频率将增长30%，从而推动马来西亚电商的总体发展。据Lazada马来西亚站的首席执行官Hans-Peter Ressel称，"2017年对电商来说是非凡的一年，尤其是对Lazada马来西亚站来说，因为我们在电商的各个领域都取得成功。"
						</p>
						<p class="text-para">
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"我们通过有效的创新调整了物流系统，并为卖家推出#EveryoneCanSell的项目，帮助他们发展在线业务。平台的SKU增长至1亿，并通过引进知名品牌，产品数量增加3倍"
						</p>
						<p class="text-para">
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"我们为2017年12月12至14日的购物狂欢节取得的胜利感到激动不已，我们期待2018年及以后马来西亚电商能够发生革命性的改变。"
						</p>
						<p class="text-para">
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Lazada主办的电商座谈会上，Hans-Peter Ressel与Facebook马来西亚主管Nicole Tan，联同大马邮政(Pos Malaysia Berhad)首席商务官Nor Azizan bin Tarja及中小型企业机构(SME Corp)首席执行官Hafsah Hashim，共同预测2018年马来西亚电商市场的五大趋势：
						</p>
						<p class="text-para">
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;马来西亚的中小企业已经在数字化转型中发挥巨大作用。事实上，1900多个中小企业已经加入最近成立的DFTZ(数字自由贸易区)来帮助他们在全球范围内推广其产品，并将他们的客户范围从3000万扩大到6亿。
						</p>
						<p class="text-para">
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;预计到2018年，加入DFTZ的中小企业数量将达到4000个。Lazada的#EveryoneCanSell项目通过在每一阶段为中小卖家提供培训和解决方案，将开展电商业务的中小企业数量增加到占比45%。
						</p>
					</div> -->

					<!-- 正文底部分隔线 -->
					<div class="body-bottom-divider"></div>

					<!-- 上下篇导航 -->
					<div class="article-nav">
						<span class="nav-prev" v-if="pagemsg.prevId" @click="getMsg(pagemsg.prevId)">
							{{$t('newsMsg.t3')}}：{{pagemsg.prevName}}
						</span>
						<span class="nav-next" v-if="pagemsg.nextId" @click="getMsg(pagemsg.nextId)">
							{{$t('newsMsg.t4')}}：{{pagemsg.nextName}}
						</span>
					</div>
					
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import newsPageHeader from '@/components/newsPageHeader.vue'
import {
	articledetail,
} from "/src/api/api.js"
export default {
	name: 'NewsDetail',
	components: {
		newsPageHeader
	},
	data() {
		return {
			pagemsg:'',
			msgOther:'',
		}
	},
	mounted() {
		this.getMsg(this.$route.query.id)
	},
	methods: {
		async getMsg(id){
			var res;
			res = await articledetail({id});
			if(res.code==200){
				this.pagemsg = res.data
			}else{this.Tips(res.msg,'error')}
		},
	}
}
</script>

<style lang="scss" scoped>
/* ===== 页面容器 ===== */
.news-detail-page {
	width: 100%;
	min-height: 100vh;
	background: #F8F8F8;
	position: relative;
}

/* ===== 内容区域 ===== */
.detail-content-section {
	padding: 0.50rem 0 0.80rem;
}
.detail-card {
	width: 13.36rem;
	// height: 9.00rem;
	margin: 0 auto;
	background: #ffffff;
	position: relative;
}

/* ===== 文章标题 ===== */
.article-title {
	// position: absolute;
	// top: 0.36rem;
	// left: 50%;
	// transform: translateX(-50%);
	text-align: center;
	padding-top: 36px;
	font-size: 0.24rem;
	font-family: 'PingFang SC', sans-serif;
	font-weight: 500;
	color: #333333;
	text-align: center;
	white-space: nowrap;
	z-index: 2;
}

/* ===== 发布日期 ===== */
.article-date {
	// position: absolute;
	// top: 0.87rem;
	// left: 50%;
	// transform: translateX(-50%);
	text-align: center;
	padding-top: 50px;
	font-size: 0.16rem;
	font-family: 'PingFang SC', sans-serif;
	font-weight: 400;
	color: #999999;
	text-align: center;
	z-index: 2;
}

/* ===== 配图 ===== */
.article-cover-wrap {
	position: absolute;
	top: 1.66rem;
	left: 0.24rem;
	width: 12.72rem;
	height: 2.25rem;
	border-radius: 0.04rem;
	overflow: hidden;
}
.article-cover {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

/* ===== 分隔线（配图下方） ===== */
.content-divider {
	position: absolute;
	top: 3.91rem;
	left: 0.24rem;
	width: 12.72rem;
	height: 0.01rem;
	background: #EEEEEE;
}

/* ===== 文章正文区域 ===== */
.article-body {
	// position: absolute;
	// top: 3.97rem;
	// left: 0.23rem;
	width: 12.70rem;
	margin-top: 36px;
	// height: 4.45rem;
}

/* 正文段落容器 */
.article-text {
	// position: absolute;
	// top: 0;
	// left: 0.25rem;
	width: 12.45rem;
	padding: 0 32px;
	// height: 3.20rem;
	font-size: 16px;
}
.text-para {
	position: absolute;
	left: 0;
	font-size: 0.16rem;
	font-family: 'PingFang SC', sans-serif;
	font-weight: 400;
	color: #545964;
	line-height: 1.75;
	width: 100%;

	&:nth-child(1) { top: 0; }
	&:nth-child(2) { top: 0.64rem; }
	&:nth-child(3) { top: 1.06rem; }
	&:nth-child(4) { top: 1.48rem; }
	&:nth-child(5) { top: 2.12rem; }
	&:nth-child(6) { top: 2.76rem; }
}

/* 正文底部分隔线 */
.body-bottom-divider {
	// position: absolute;
	// top: 3.52rem;
	// left: 0;
	margin: 32px 32px;
	margin-bottom: 0;
	width: 11.52rem;
	height: 0.01rem;
	background: #EEEEEE;
}

/* 上下篇导航 */
.article-nav {
	// position: absolute;
	// top: 3.77rem;
	// left: 0.25rem;
	margin: 0 32px;
	padding: 32px 0;
	display: flex;
	flex-direction: column;
	gap: 0.46rem;
	.nav-prev,
	.nav-next {
		font-size: 0.16rem;
		font-family: 'PingFang SC', sans-serif;
		font-weight: 400;
		cursor: pointer;
		transition: color 0.3s;
		white-space: nowrap;
	}
	.nav-prev {
		color: #545964;
		&:hover { color: #0096FF; }
	}
	.nav-next {
		color: #0096FF;
		&:hover { opacity: 0.8; }
	}
}
</style>
